import { render, staticRenderFns } from "./PiConfig.vue?vue&type=template&id=4c139673&scoped=true"
import script from "./PiConfig.vue?vue&type=script&lang=js"
export * from "./PiConfig.vue?vue&type=script&lang=js"
import style0 from "./PiConfig.vue?vue&type=style&index=0&id=4c139673&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c139673",
  null
  
)

export default component.exports